// src/pages/Dashboard/Admin/DetailsAdherents/components/BeltsPanel.jsx

import React, { useMemo } from "react";
import ButtonDiplome from "../../../../../components/Button/ButtonDiplome";
import DashboardDataTable from "./DashboardDataTable";

import { formatDate, safeArray } from "../utils/adherentDashboardUtils";

export default function BeltsPanel({ belts, adherent }) {
  const rows = useMemo(() => {
    return safeArray(belts).sort(
      (a, b) =>
        new Date(b?.date_passage || 0).getTime() -
        new Date(a?.date_passage || 0).getTime()
    );
  }, [belts]);

  return (
    <DashboardDataTable
      minWidth="920px"
      columns={[
        {
          key: "belt",
          label: "Ceinture",
          render: (row) => {
            const belt = row?.BeltColor || {};
            const image = belt?.belt_url
              ? `/img/belt/${belt.belt_url}`
              : "/img/belt/ceinture-inconnue.png";

            return (
              <div className="flex items-center gap-3">
                <img
                  src={image}
                  alt={belt?.nom || "Ceinture"}
                  className="h-10 w-20 rounded-xl object-contain bg-white ring-1 ring-slate-200 dark:bg-slate-800 dark:ring-slate-700"
                />
                <div>
                  <p className="font-semibold text-slate-900 dark:text-white">
                    {belt?.nom || "—"}
                  </p>
                  <p className="text-xs text-slate-500 dark:text-slate-400">
                    Ordre {belt?.ordre ?? "—"}
                  </p>
                </div>
              </div>
            );
          },
        },
        {
          key: "date_passage",
          label: "Date de passage",
          render: (row) => formatDate(row?.date_passage),
        },
        {
          key: "diplome",
          label: "Diplôme",
          render: (row) => {
            const belt = row?.BeltColor || {};
            const ordre = typeof belt?.ordre === "number" ? belt.ordre : null;
            const showDiplome = ordre !== null && ordre >= 2 && ordre <= 13;

            if (!showDiplome) return "—";

            return (
              <ButtonDiplome
                adherentId={adherent?.id}
                datePassage={row?.date_passage}
                beltImage={belt?.belt_url}
                beltName={belt?.nom}
                adherentNom={adherent?.nom}
                adherentPrenom={adherent?.prenom}
                dateNaissance={adherent?.date_naissance}
              />
            );
          },
        },
      ]}
      rows={rows}
      emptyMessage="Aucun passage de ceinture enregistré."
    />
  );
}